/**
 * LoadingState - Loading indicator with optional message
 */

import { FC } from 'react';
import { Box, CircularProgress, Typography, Skeleton, Stack } from '@mui/material';

export interface LoadingStateProps {
  message?: string;
  variant?: 'spinner' | 'skeleton';
  rows?: number;
}

export const LoadingState: FC<LoadingStateProps> = ({
  message = 'Loading...',
  variant = 'spinner',
  rows = 3,
}) => {
  if (variant === 'skeleton') {
    return (
      <Stack spacing={2}>
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            height={60}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}
    >
      <CircularProgress size={40} />
      {message && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};
